export default function SiteSelector({ sites, selectedSiteId, onChange, variant = 'default' }) {
  const hasMany = (sites || []).length > 1;
  const hasNone = (sites || []).length === 0;

  if (hasNone) {
    return <div className="Muted">Aucun site</div>;
  }

  if (!hasMany) {
    const site = sites[0];
    return (
      <div className={`SiteSingle ${variant === 'sidebar' ? 'SiteSingle--sidebar' : ''}`} aria-label="Site sélectionné">
        <div className="SiteName">{site.name}</div>
        {site.domain ? <div className="SiteDomain">{site.domain}</div> : null}
      </div>
    );
  }

  return (
    <div className="Field">
      <label className="SrOnly" htmlFor="site-selector">
        Sélectionner un site
      </label>
      <select
        id="site-selector"
        className={`Select ${variant === 'sidebar' ? 'Select--site' : ''}`}
        value={selectedSiteId ?? ''}
        onChange={(e) => onChange(Number(e.target.value))}
      >
        {(sites || []).map((s) => (
          <option key={s.id} value={s.id}>
            {s.name}
          </option>
        ))}
      </select>
    </div>
  );
}
